<template>
  <DashboardLayout>
    <div class="d-flex align-items-center gap-2 mb-4 page-identifier">
      <router-link :to="{ name: 'ViewSpecialApprovalTypes' }" class="mb-0 main-identifier fw-semibold text-decoration-none"
        title="Go back to Special Approval Types">
        Special Approval Types
      </router-link>
      <span class="material-symbols-outlined">keyboard_arrow_right</span>
      <p class="mb-0 sub-identifier">Create Special Approval Type</p>
    </div>
    <div class="d-flex justify-content-center">
      <div class="form-outer">
        <form @submit.prevent="handleSubmit">
          <div class="crud-form position-relative">
            <div class="form-inner">
              <div class="form-header d-flex justify-content-between align-items-center">
                <h1 class="mb-0">Create Special Approval Type</h1>
              </div>
              <div class="form-body">
                <div class="row mt-2 mb-3">
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center">
                      <label class="form-label">Name</label>
                    </div>
                    <div class="col-md-9 input-right">
                      <input type="text" class="form-control" v-model="name" required />
                    </div>
                  </div>
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center">
                      <label class="form-label">Description</label>
                    </div>
                    <div class="col-md-9 input-right">
                      <input type="text" class="form-control" v-model="description" required />
                    </div>
                  </div>
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center">
                      <label class="form-label">Maximum Amount</label>
                    </div>
                    <div class="col-md-9 input-right">
                      <input type="number" class="form-control" v-model="maxAmount" required />
                    </div>
                  </div>
                  <div class="col-md-12 row form-group position-relative floating-label-group">
                    <div class="col-md-3 label-left d-flex justify-content-end align-items-center">
                      <label class="form-label">Approval Type</label>
                    </div>
                    <div class="col-md-9 input-right d-flex gap-5">
                      <div class="form-check d-flex flex-column align-items-center gap-2">
                        <input class="form-check-input mt-0" type="checkbox" id="globalApproval" v-model="globalApproval" />
                        <label class="form-check-label" for="globalApproval">Global Approval</label>
                      </div>
                      <div class="form-check d-flex flex-column align-items-center gap-2">
                        <input class="form-check-input mt-0" type="checkbox" id="monthlyApproval" v-model="monthlyApproval" />
                        <label class="form-check-label" for="monthlyApproval">Monthly Approval</label>
                      </div>
                    </div>
                  </div>
                  <div class="d-flex justify-content-center">
                    <button class="submit-btn" type="submit" :disabled="loading">
                      <span v-if="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                      {{ loading ? 'Submitting...' : 'Submit' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </DashboardLayout>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import Cookies from 'js-cookie'
import Swal from 'sweetalert2'
import { useRouter } from 'vue-router'
import DashboardLayout from '../../layout/DashboardLayout.vue'

const root_api_url = process.env.VUE_APP_API_ROOT_URL
const router = useRouter()

const name = ref('')
const description = ref('')
const maxAmount = ref('')
const globalApproval = ref(false)
const monthlyApproval = ref(false)
const loading = ref(false)

const iconHtmlSuccess = `<span class="iconify" data-icon="ci:circle-check" style="font-size: 100px; color: green;"></span>`
const iconHtmlError = `<span class="iconify" data-icon="material-symbols:cancel-outline-rounded" style="font-size: 100px; color: red;"></span>`

const handleSubmit = async () => {
  const token = Cookies.get('auth_token')
  loading.value = true

  const payload = {
    name: name.value,
    description: description.value,
    maxAmount: Number(maxAmount.value),
    globalApprovalInd: globalApproval.value ? 1 : 0,
    monthlyApprovalInd: monthlyApproval.value ? 1 : 0,
    newEntity: true,
  }

  try {
    await axios.post(`${root_api_url}/appraisal/spec-approval-type`, payload, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }, 
    })

    await Swal.fire({
      html: `${iconHtmlSuccess} <h1 style="font-weight:600;">Success</h1> <p>Special Approval Type created successfully.</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    })

    router.push({ name: 'ViewSpecialApprovalTypes' })
  } catch (error) {
    Swal.fire({
      html: `${iconHtmlError}
      <h1 style="font-weight:600;">Error</h1>
      <p>${error?.response?.data?.errorMessage ?? error?.response?.data?.error ?? error?.response?.data?.message ?? 'Unexpected error occurred while creating special approval type. Kindly contact administrator'}</p>`,
      showConfirmButton: true,
      showCloseButton: true,
      icon: undefined,
    })
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
</style>
